import { WorkbookModel } from "@xlsx-model/models";
import DynamicReportModel from "@/models/DynamicReportModel";

export default class DynamicReportState {
  dynamicReport?: DynamicReportModel;
  dynamicReportData?: WorkbookModel;
}
